import gtrStorage from './storage.service'
import { KIOSK_TOKEN_KEY } from './keys'

class SecurityContext {
  token(course_uuid?: string): string | null {
    return gtrStorage.getItem(`${course_uuid}_registration_access_token`)
  }

  kioskToken(): string | null {
    const raw = localStorage.getItem(KIOSK_TOKEN_KEY)
    return raw ? JSON.parse(raw) : null
  }
}

export default new SecurityContext()
